var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafetySearchColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da291c;}.cls-2{fill:#545859;}.cls-3{fill:#d9d9d6;}.cls-4{fill:#ed8b00;}.cls-5{fill:none;}.cls-6{fill:#eaaa00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    className: "cls-3",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Safety_Search"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.45 20.78 119.45 60.39 159.06 60.39 119.45 20.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.55 20.78 40.94 20.78 40.94 179.22 159.06 179.22 159.06 70.29 109.55 70.29 109.55 20.78"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 95,
    cy: 115,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m111.85,140.74l20.55,20.53c2.03,2.03,5.32,2.03,7.35,0,2.03-2.03,2.03-5.32,0-7.35l-20.55-20.53c-2.06,2.81-4.54,5.29-7.35,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m91.95,90.14c12.9,0,23.35,10.45,23.35,23.35s-10.45,23.35-23.35,23.35-23.35-10.45-23.35-23.35,10.45-23.35,23.35-23.35Zm0,57.08c18.63,0,33.73-15.1,33.73-33.73s-15.1-33.73-33.73-33.73-33.73,15.1-33.73,33.73,15.1,33.73,33.73,33.73Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetySearchColor);
export default __webpack_public_path__ + "static/media/SafetySearch_Color.75fbd410d4a8837312ffaea94f536e8d.svg";
export { ForwardRef as ReactComponent };